import { displayMoney } from "../helpers";
import { getVariable } from "../services/config";

const VARIABLES = {
  // (gültig bis Dec 31, 2023)
  "[Mindestgehaltsgrenze]": { type: "EUR", value: getVariable("minIncome") },

  // (gültig bis Dec 31, 2023)
  "[Mindestgehaltsgrenze Mangelberuf]": {
    type: "EUR",
    value: getVariable("minIncomeUnderstaffedJobs"),
  },

  "[National Visa Fee]": { type: "EUR", value: getVariable("nationalVisaFee") },

  "[Reduced National Visa Fee]": {
    type: "EUR",
    value: getVariable("reducedNationalVisaFee"),
  },

  // (60% der Beitragsbemessungsgrenze der allgemeinen Rentenversicherung gültig bis Dec 31, 2023)
  "[Mindestgehaltsgrenze IT-Fachkräfte ohne Ausbildung]": {
    type: "EUR",
    value: getVariable("minIncomeITProWoEducation"),
  },

  // (55% der Beitragsbemessungsgrenze der allgemeinen Rentenversicherung gültig bis Dec 31, 2023)
  "[Mindestgehaltsgrenze über 45 Jahre]": {
    type: "EUR",
    value: getVariable("minIncomeAgeOver45"),
  },

  "[Höchstsatz Residence Permit]": {
    type: "EUR",
    value: getVariable("residencyPermitMaxFee"),
  },
};

export function replaceVariables(text) {
  for (let key in VARIABLES) {
    const { type, value } = VARIABLES[key];
    text = text.replace(
      key,
      type == "EUR" ? displayMoney(value, "EUR") : value
    );
  }
  return text;
}
